
import { Options } from "vue-class-component";
import Base from "../base/Base.vue";
import ChallengeService from "../../services/challenge.service";
import { Question } from "../../model/Question.model";
import { ref, computed } from "vue";
import { Answer } from "../../model/Answer.model";
import { ChallengeType } from "../../enum/challenge.type";
import { ChallengeSettings } from "../../model/ChallengeSettings.model";
import { IGalleria } from "@/model/IGalleria.model";
import LayoutService from "@/services/layout.service";
@Options({})
export default class PreviewQuestion extends Base {
  answers = ref<Answer[]>([]);
  answersPreview = ref<any[]>([]);
  numberQuestion = 0;
  imageQuestion = "";
  questionName = "";
  correctAnswer = "";
  maxWords: any = 0;
  wordAnswers: any = 0;
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  public secondsToAnswer: any = 0;
  created() {
    ChallengeService.getQuestion.subscribe((question: Question) => {
      const {
        index,
        answers,
        name,
        correctAnswer,
        image,
        secondsToAnswer
      } = question;
      this.numberQuestion = (index as number) + 1;
      this.answers.value = answers;
      this.questionName = name;
      this.correctAnswer = correctAnswer;
      this.imageQuestion = image;
      this.secondsToAnswer = secondsToAnswer;
      if (this.checkChallengeType().openEnded) {
        this.maxWords = question.maxWords;
      }
      this.answersPreview.value = this.answers.value.map((a, index) => {
        const classAns = this.classAnswers.find((c, i) => i === index);
        return {
          ...a,
          class: classAns
        };
      });
    });
  }

  inputTextarea(event: any) {
    this.wordAnswers = event.target.value.length;
  }

  public checkChallengeType() {
    const name = this.settingsChallenge.name.toLowerCase();
    return {
      quiz: name === ChallengeType.quiz,
      poll: name === ChallengeType.poll,
      openEnded: name === ChallengeType.openEnded,
      random: name === ChallengeType.random
    };
  }
  classAnswers = [
    "answers-0",
    "answers-1",
    "answers-2",
    "answers-3",
    "answers-4",
    "answers-5",
    "answers-6",
    "answers-7"
  ];

  openGalleria() {
    const galleria: IGalleria = {
      visible: true,
      value: [
        {
          src: this.imageQuestion,
          alt: "image"
        }
      ]
    };
    LayoutService.setGalleria(galleria);
  }
}
